export default __webpack_public_path__ + "static/media/Gram.efb16961.jpg";